import axios from "axios";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingContent from "../../components/LoadingContent";
import { useUser } from "../../components/UserContext";
import "../../assets/style/transfers.css";
import Button from "../../components/Button";

const Transfers = ({
  setUpdateNotification,
  isSecondChamp,
}: {
  setUpdateNotification: Dispatch<SetStateAction<boolean>>;
  isSecondChamp?: boolean;
}) => {
  const { t } = useTranslation();
  const { user } = useUser() as any;
  const [data, setData] = useState<{
    picker_list: { driver: { username: string }; state: number }[];
    final_titular_drivers: {
      team_championship_id: number;
      drivers: DriverEntry[];
    }[];
  }>();
  document.title = "LVF1 - " + t("Transfers");
  const [showSignButton, setShowSignButton] = useState(false);
  const [update, setUpdate] = useState(false);
  const [show, setShow] = useState(false);
  const [teamSelected, setTeamSelected] = useState<DriverEntry>();
  const [number, setNumber] = useState();
  const [error, setError] = useState(0);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/main/getNewChampionshipData`,
        {
          params: {
            isSecondChamp: isSecondChamp ? 1 : 0,
            user,
          },
        },
      )
      .then(({ data }) => {
        data.final_titular_drivers.sort(
          (a: any, b: any) => a.drivers[0].number - b.drivers[0].number,
        );
        setData(data);
        setShowSignButton(data.available);
      })
      .catch(({ response }) => {
        console.log(response);
        throw new Error(response);
      });
  }, [user, update, isSecondChamp]);

  const skipShift = () => {
    let token = window.localStorage.getItem("userLogged");
    if (token == null) return;
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/championship/skipShift`,
        {
          user,
          token: JSON.parse(token).token,
          isSecondChamp,
        },
      )
      .then(() => {
        toast.success(`${t("TurnShifted")}`);

        setUpdateNotification((prev) => {
          return !prev;
        });
        setUpdate(!update);
      })
      .catch(({ response }) => {
        console.log(response);
        toast.error(`${t("Error!")}`);
        throw new Error(response);
      });
  };

  const sign = (assignment: DriverEntry) => {
    setTeamSelected(assignment);
    handleShow();
  };

  const checkNumber = () => {
    setError(0);
    if (
      (teamSelected?.number == null && number == null) ||
      (teamSelected?.number == null && number == "") ||
      number == "0"
    ) {
      setError(1);
      return false;
    }
    if (data != null && number != null) {
      let number_exists = false;
      data.final_titular_drivers.map((team) => {
        team.drivers.map((driver: any) => {
          if (driver != null && driver.number === parseInt(number)) {
            setError(2);
            number_exists = true;
            return;
          }
        });
      });
      if (number_exists) return false;
    }
    if (
      data != null &&
      number != null &&
      parseInt(number) === 1 &&
      data.picker_list.length > 0 &&
      user != data.picker_list[0].driver.username
    ) {
      setError(3);
      return false;
    }
    return true;
  };

  const signPost = () => {
    if (!checkNumber()) return;
    let token = window.localStorage.getItem("userLogged");
    if (token == null) return;
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/championship/signTeam`,
        {
          user,
          token: JSON.parse(token).token,
          id: teamSelected?.assignment_id,
          number,
          isSecondChamp,
        },
      )
      .then(() => {
        toast.success(`${t("TeamSignUpOK")}`);

        setUpdateNotification((prev) => {
          return !prev;
        });
        setUpdate(!update);
        setShow(false);
      })
      .catch(({ response }) => {
        console.log(response);
        toast.error(`${t("Error!")}`);
        throw new Error(response);
      });
  };

  if (data == null) return <LoadingContent />;

  const showList =
    data.picker_list != null &&
    data.picker_list.length > 0 &&
    data.picker_list.filter(
      (list: { state: number; driver: { username: string } }) =>
        list.state === 0,
    ).length > 0;

  // Comprobamos si el usuario ya está inscrito en algún equipo
  const userAlreadySigned = data.final_titular_drivers.some((team) =>
    team.drivers.some(
      (driver: DriverEntry) => driver != null && driver.username === user,
    ),
  );

  // Puede aparecer el botón de firmar solamente si:
  // - Hay plazas disponibles
  // - El usuario todavía no está en un equipo
  const canSign = showSignButton && !userAlreadySigned;

  return (
    <div className="full-height padding-lg app-container flex-center-top page-transition">
      <div
        id="transfers-container"
        className={showList ? "transfers-layout" : "transfers-layout no-picker"}
      >
        {/* ========================================================= */}
        {/* LISTA DE ELECCIÓN                                         */}
        {/* ========================================================= */}

        {showList && (
          <aside id="picker-list">
            <div className="picker-header">
              <h3>{t("ListOfSelection")}</h3>

              <span className="picker-count">
                {data.picker_list.length} {t("Drivers")}
              </span>
            </div>

            <div className="picker-drivers">
              {data.picker_list.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`picker-driver transfers${item.state}`}
                  >
                    <span className="picker-position">{index + 1}</span>

                    <span className="picker-name">{item.driver.username}</span>
                  </div>
                );
              })}
            </div>

            {data.picker_list.find(
              (list: { state: number; driver: { username: string } }) =>
                list.state === 0 && list.driver.username === user,
            ) && (
              <div className="picker-footer">
                <Button
                  text={t("SkipShift")}
                  onClick={skipShift}
                  className="button-orange-lvf1"
                />
              </div>
            )}
          </aside>
        )}

        {/* ========================================================= */}
        {/* EQUIPOS                                                    */}
        {/* ========================================================= */}

        <section id="teams-list">
          <div className="teams-title">
            <h3>{t("Teams")}</h3>

            <div className="teams-title-line" />
          </div>

          <div className="teams-grid">
            {data.final_titular_drivers.map((team, index: number) => {
              const teamName =
                team.drivers.find((driver: DriverEntry) => driver != null)
                  ?.team_name || "";

              const drivers = team.drivers || [];

              return (
                <article key={index} className="team-card">
                  {/* Barra superior con el color del equipo */}
                  <div className="team-card-accent" />

                  {/* CABECERA */}
                  <div className="team-card-header">
                    <Link
                      to={`${t("routes:Team")}/${encodeURIComponent(teamName)}`}
                      className="team-name"
                    >
                      {teamName}
                    </Link>
                  </div>

                  {/* COCHE */}
                  <Link
                    to={`${t("routes:Team")}/${encodeURIComponent(teamName)}`}
                    className="team-car"
                  >
                    <img
                      alt={teamName}
                      title={teamName}
                      src={`/assets/TeamChampionship/${team.team_championship_id}.png`}
                    />
                  </Link>

                  {/* PILOTOS */}
                  <div className="team-drivers">
                    {drivers.map((driver_: DriverEntry, driverIndex) => {
                      const isEmpty =
                        driver_ == null || driver_.username == null;

                      return (
                        <div
                          key={driverIndex}
                          className={`team-driver ${
                            isEmpty ? "team-driver-empty" : ""
                          }`}
                        >
                          {isEmpty ? (
                            <>
                              <div className="empty-driver">
                                <span className="empty-driver-icon">+</span>

                                <span>{t("Available")}</span>
                              </div>

                              {canSign && (
                                <Button
                                  text={t("Sign")}
                                  onClick={() => sign(driver_)}
                                  className="button-sign-team"
                                />
                              )}
                            </>
                          ) : (
                            <>
                              <span
                                className="driver-number"
                                style={{
                                  background: driver_.main_color,
                                  color: driver_.secondary_color,
                                }}
                              >
                                {driver_.number}
                              </span>

                              <Link
                                className="driver team-driver-name"
                                title={driver_.username}
                                to={`${t("routes:Driver")}/${encodeURIComponent(
                                  driver_.username,
                                )}`}
                              >
                                {driver_.username}
                              </Link>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* PIE DE TARJETA */}
                  <div className="team-card-footer">
                    <span>
                      <strong>
                        {
                          drivers.filter(
                            (driver: DriverEntry) =>
                              driver != null && driver.username != null,
                          ).length
                        }
                      </strong>
                      {" / "}
                      {drivers.length} {t("Drivers")}
                    </span>

                    {drivers.every(
                      (driver: DriverEntry) =>
                        driver != null && driver.username != null,
                    ) && (
                      <span className="team-complete">✓ {t("Complete")}</span>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      </div>

      {/* ========================================================= */}
      {/* MODAL DE INSCRIPCIÓN                                      */}
      {/* ========================================================= */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Sign")} - {teamSelected?.team_name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {teamSelected?.number == null ? t("TextSign") : t("TextSign2")}

          {teamSelected?.number == null && (
            <Form.Control
              required
              type="number"
              onChange={(e: any) => {
                setNumber(e.target.value);
              }}
            />
          )}

          <p className="red">
            {error === 1
              ? t("NumberBad")
              : error === 2
                ? t("NumberChoosen")
                : error === 3
                  ? t("NumberBad2")
                  : ""}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            text={t("Close")}
            onClick={handleClose}
            className="button-neutral-lvf1"
          />

          <Button text={t("Sign")} onClick={signPost} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Transfers;
